
import { Event } from '@/module/event/domain/model/event';
import { Place } from '@/module/place/domain/model/place';
import { PropType } from 'vue';

export default {
  name: 'LastPlaceEvent',
  props: {
    lastEvent: {
      type: Object as PropType<Event>,
      required: false
    },
    place: {
      type: Object as PropType<Place>,
      required: true
    }
  }
}
